<template>
  <h1 :class='totalsClass'>
    {{ text }}
  </h1>
</template>

<script>
export default {
  name: 'report-header',
  props: {
    text: {
      required: true
    }
  },
  data: () => ({
    totalsClass: 'mt-6 headline font-weight-light text-uppercase'
  })
}
</script>